module.exports = __webpack_public_path__ + "img/twitter-brands.69efd79d.svg";